import { ClientSideError, ClientSideErrorType, cloneErrorObject, logger } from '@dtx-company/logger'
import { ITHACA_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { LockedFeatures } from '@dtx-company/inter-app/src/redux/slices/lockedFeaturesSlice'

export async function fetchLockedFeatures(): Promise<LockedFeatures | undefined> {
  try {
    const res = await fetch(`${ITHACA_ENDPOINT}/v1/locked-features`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (res.ok) {
      const json = await res.json()
      const lockedFeatures: LockedFeatures = json.lockedFeatures

      if (!lockedFeatures) {
        throw new Error('Failed to get locked features - no data returned from Ithaca')
      }

      return lockedFeatures
    } else {
      await logger?.logFetchError(res, { technicalArea: 'authentication' })
    }
  } catch (e) {
    logger.logError(
      new ClientSideError({
        ...cloneErrorObject(e),
        type: ClientSideErrorType.DefaultError
      }),
      { technicalArea: 'authentication' }
    )
  }
}

// mock function until endpoint is ready
export const mockFetchLockedFeatures = async (): Promise<LockedFeatures> => {
  // Simulated delay
  await new Promise(resolve => setTimeout(resolve, 500))

  // Mock response
  return {
    'view:hex_color_code': 'personal_plan:pro',
    'view:hex_color_page': 'personal_plan:pro',
    'view:page_fonts': 'personal_plan:pro',
    'view:smart_rules': 'personal_plan:pro',
    'view:mailchimp_crm_option': 'personal_plan:pro',
    'view:pro_upsell_or_upgrade': 'personal_plan:pro',
    'view:page_style_options': 'personal_plan:pro',
    'view:analytics_top_codes_chart': 'personal_plan:pro',
    'view:analytics_top_pages_chart': 'personal_plan:pro',
    'view:analytics_top_tags_chart': 'personal_plan:pro',
    'view:analytics_top_destinations_chart': 'personal_plan:pro',
    'view:analytics_traffic_chart': 'personal_plan:pro',
    'view:analytics_top_links_chart': 'personal_plan:pro',
    'view:analytics_utm_charts': 'personal_plan:pro',
    'view:analytics_export_csv': 'personal_plan:pro',
    'view:free_text_center': 'personal_plan:pro',
    'view:remove_footer_branding_slot': 'personal_plan:pro',
    'view:zapier_crm_option': 'org_plan:pro_plus',
    'view:analytics_export_pdf': 'org_plan:pro_plus',
    'view:link_style_options': 'org_plan:pro_plus',
    'view:pro_plus_upsell_modal': 'org_plan:pro_plus',
    'view:domains_page': 'org_plan:pro_plus',
    'view:flowteams': 'org_plan:pro_plus',
    'view:flowcode_eye_branding_toggle': 'org_plan:pro_plus',
    'view:interstitial_geolocation': 'org_plan:pro_flex',
    'view:hubspot_crm_option': 'org_plan:pro_flex'
  }
}
